import { Component } from "@angular/core";
import { DialogService } from "../../bootstrap-modal/dialog.service";
import { DialogComponent } from "../../bootstrap-modal/dialog.component";

export interface XlsxConvertModel { }

@Component({
    templateUrl: "./dialog-convert-to-xlsx.template.pug",
    providers: [
    ],
})
export class ConvertToXlsxDialogComponent extends DialogComponent<XlsxConvertModel, string>
    implements XlsxConvertModel {

    constructor(public dialogService: DialogService) {
        super(dialogService);
    }

    cancel(): void {
        this.result = null;
        this.close();
    }
}